function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import Provider from "./BaseProvider";
import isFunction from "lodash/isFunction";
import options from "../../apiV2/ProviderOptions";
import debounce from "lodash/debounce";
// import type { Store } from 'redux';
var ChartProvider = /*#__PURE__*/ function(Provider) {
    "use strict";
    _inherits(ChartProvider, Provider);
    var _super = _createSuper(ChartProvider);
    function ChartProvider() {
        _classCallCheck(this, ChartProvider);
        var _this;
        _this = _super.call(this);
        _defineProperty(_assertThisInitialized(_this), "_onChartMessageReceived", function(uid, msgId, data, transactionId) {
            switch(msgId){
                case "requestChange":
                    console.log("CHART PROVIDER change requested");
                    if (_this.changeRequested) {
                        // TODO: optionial / hacky way to talk to the rails bridge form editor
                        //  This function is dynamically set by the editor
                        _this.changeRequested(data);
                    }
                    break;
                case "jumpToChart":
                    _this.jumpToChartLegacy(data);
                    break;
                case "jumpToChartV2":
                    _this.jumpToChart(data);
                    break;
            }
        });
        _defineProperty(_assertThisInitialized(_this), "_onChartAssetMessageReceived", function(uid, msgId, data, transactionId) {
            switch(msgId){
                case "requestIndex":
                    _this._indexAssets(uid, msgId, data, transactionId);
                    break;
                case "requestClaim":
                    if (_this.externAssetBridge && _this.externAssetBridge.requestClaim) {
                        _this.externAssetBridge.requestClaim(data);
                    }
                    break;
                case "releaseClaim":
                    if (_this.externAssetBridge && _this.externAssetBridge.releaseClaim) {
                        _this.externAssetBridge.releaseClaim(data);
                    }
                    break;
            }
        });
        _defineProperty(_assertThisInitialized(_this), "_indexAssets", function(uid) {
            var msgId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, transactionId = arguments.length > 3 ? arguments[3] : void 0;
            if (_this.externAssetBridge && _this.externAssetBridge.indexClaims) {
                _this.externAssetBridge.indexClaims(data.requestId || transactionId, function(msgId, data) {
                    var tid = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : transactionId;
                    return _this.publish(uid, "chartAsset", msgId, data, tid);
                }, options(uid));
            }
        });
        _defineProperty(_assertThisInitialized(_this), "setDataGetter", function(getDataFunc) {
            _this._getData = !!getDataFunc && isFunction(getDataFunc) ? getDataFunc : _this._getData;
        });
        // Fanout Data to all Subscriptions
        _defineProperty(_assertThisInitialized(_this), "dispatch", function() {
            _this.fanout("chart", "changed", _this._getData);
        });
        // Internal functions
        _defineProperty(_assertThisInitialized(_this), "_getData", function(options) {
            // These are the Default return values
            console.warn("No Data Getter Set. Returning Default Values. Set a Getter with ChartProvider.setDataGetter(Function)");
            return {
                then: function then(fn) {
                    fn({
                        meta: {},
                        content: "{}"
                    });
                    return {
                        catch: function _catch(fn) {}
                    };
                }
            };
        });
        _defineProperty(_assertThisInitialized(_this), "DataStruct", function(chart, content) {
            return {
                meta: {},
                content: !!content && content.cont ? content.cont : "{}"
            };
        });
        _this.dispatch = debounce(_this.dispatch, 100);
        return _this;
    }
    _createClass(ChartProvider, [
        {
            // When there is a new listener subscribed
            key: "onSubscribed",
            value: function onSubscribed(uid, data) {
                var _this = this;
                // Initialization Message
                this._getData(options(uid)).then(function(_data) {
                    _this.publish(uid, "chart", "meta", _data);
                    _this.publish(uid, "chart", "changed", _data);
                    _this._indexAssets(uid);
                }).catch(function(err) {
                    _this.publish(uid, "chart", "failed", {
                        status: "failed",
                        error: err
                    });
                });
            }
        },
        {
            // When an extension sends data
            key: "onMessageReceived",
            value: function onMessageReceived(uid, channel, msgId, data, transactionId) {
                switch(channel){
                    case "chart":
                        this._onChartMessageReceived(uid, msgId, data, transactionId);
                        break;
                    case "chartAsset":
                        this._onChartAssetMessageReceived(uid, msgId, data, transactionId);
                        break;
                    default:
                        console.warn("ChartProvider.js> channel '" + channel + "' is not implemented!");
                }
            }
        },
        {
            key: "jumpToChart",
            value: function jumpToChart(chartId) {
                console.warn("No jump function defined");
            }
        },
        {
            key: "jumpToChartLegacy",
            value: function jumpToChartLegacy(chartId) {
                console.warn("No jump function defined");
            }
        },
        {
            key: "reduxMiddleware",
            value: function reduxMiddleware(store, action, uid) {
                var _this = this;
                if (this.externAssetBridge && this.externAssetBridge.reduxAction) {
                    this.externAssetBridge.reduxAction(store, action, function(msgId, data) {
                        var rid = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : action.requestId;
                        return _this.publish(uid, "chartAsset", msgId, data, rid);
                    });
                }
                return action;
            }
        }
    ]);
    return ChartProvider;
}(Provider);
ChartProvider.providedChannels = [
    "chart",
    "chartAsset"
];
var _ChartProvider = new ChartProvider();
export default _ChartProvider;
